export enum LinkType {
  youtube = <any>'youtube',
  vimeo = <any>'vimeo',
  soundcloud = <any>'soundcloud'
}
